<!DOCTYPE html>
<template>
	<b-form @submit.prevent="createDocument">
		<div class="company-name">
			<b-form-group label="Company Name" label-for="company-name-input">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="building" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="company-name-input" type="text" v-model="companyName" placeholder="Company Name"/>
				</b-input-group>
			</b-form-group>
		</div>
		<b-form-group class="document_metadata">
			<b-table-lite striped hover :items="dataDTO">
			</b-table-lite>
			<b-form-group label="Entry key" label-for="entry-key-input">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="info-square-fill" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="entry-key-input" type="text" v-model="data_key" placeholder="Entry"/>
				</b-input-group>
			</b-form-group>
			<b-form-group label="Entry value" label-for="entry-value-input">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="file-earmark-plus-fill" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="entry-value-input" type="text" v-model="data_value" placeholder="Value"/>
				</b-input-group>
			</b-form-group>
			<b-button type="button" @click="addDataToMap">Add Property</b-button>
		</b-form-group>
		<b-form-group class="qr_code">
			<canvas ref="document_result" aria-label="Generated QR code"/>
		</b-form-group>
		<b-button type="submit">Create Document Metadata</b-button>
	</b-form>
</template>
<style lang="scss" scoped>
	.icon {
		margin: auto;
		padding: var(--secudoc-space-2);
		font-size: 1rem;
		color: var(--secudoc-on-surface-variant);
	}
</style>
<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import { renderFramedQr } from "@/utils/framedQr";
	import { logEvent } from '@/firebaseAnalytics';

	class Document {
		constructor() {
		
		}
	}
	var documentConverter = {
		toFirestore: function(document) {
			return {
				companyName: document.companyName,
				createdDate: document.createdDate,
				metadata: document.metadata,
			}
		},
		fromFirestore: function(snapshot, options) {
			const data = snapshot.data(options);
			var document = new Document();
				document.companyName = data.companyName;
				document.createdDate = data.createdDate.toDate().toLocaleDateString("en-US");
				document.metadata = data.metadata;
			return document;
		}
	}
	export default {
		methods: {
			addDataToMap() {
				var val = {
					account_property: this.data_key,
					value: this.data_value
				}

				this.dataDTO.push(val);
				this.data[this.data_key] = this.data_value;
				this.data_key = "";
				this.data_value = "";
			},
			createDocument() {
				var document = new Document();
				document.companyName = this.companyName;
				document.createdDate = new Date();
				document.metadata = this.data;
				firebase.firestore().collection("Documents")
					.doc(firebase.auth().currentUser.uid).collection("Metadata")
					.withConverter(documentConverter).add(document).then(docResult => {
						logEvent('document_created', { company_name: document.companyName });
						// cannot use Firebase ML Kit to create QR code (Android/iOS only) —
						// render the branded QR onto the result canvas via the shared helper.
						renderFramedQr(docResult.id, this.$refs.document_result)
							.catch(error => console.error(error));
					});
			},
			viewMetadata: function(_id) {
				alert("view " + _id + "\nIn progress (currently not available)");
			}
		},
		data() {
			return {
				uid: "",
				firstName: "",
				middleName: "",
				lastName: "",
				birthdate: null,
				fullAddress: "",
				prcId: "",
				email: "",
				password: "",
				confirmPassword: "",
				role: -1,
				error: "",
				
				
				docList: [],
				companyName: "",
				data: {},
				data_key: "",
				data_value: "",
				dataDTO: []
			}
		}
	}
</script>

